<template>
  <div>
      <JSONTemplateTransactionGroupEditor v-if="template" :template="template" :bound_variables="{cidr_base: cidr, is_reserved: true, is_dhcp: false}"
                                          :modal_id="modal_id" :old_uuid="null" />
  </div>
</template>

<script>
import JSONTemplateTransactionGroupEditor from '@/components/db-editor/JSONTemplateTransactionGroupEditor.vue'
import Axios from 'axios'

export default {
  name: 'ReserveIPAddrDBEditor',
  components: { JSONTemplateTransactionGroupEditor },
  async created() {
    this.template = (await Axios.get('/bundled_json_templates/ip_addr_range_edit.json')).data
  },
  data() {
    return {
      template: null,
    }
  },
  props: {
    modal_id: {
      type: String,
      required: true
    },
    cidr: {
      type: String,
      required: true,
      default: null
    },

  }
}
</script>

<style scoped>

</style>
